import { Component } from '@angular/core';
import { IconComponent } from '@app/components/icon/icon.component';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [IconComponent],
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.css',
})
export class FooterComponent {
	resourceUrl = environment.production
		? 'wwwservizi.regione.emilia-romagna.it'
		: 'wwwservizitest.regione.emilia-romagna.it';
}
